
<content-block
	[title]="'CoordonneeBancaire.Title' | translate" 
	[isLoading]="alfrescoDocumentsLoader || loader"
	[headerActions]="contentBlockActions"
	classList="has-spacer"
>
<loader-spinner [model]="alfrescoDocumentsLoader"></loader-spinner>
<loader-spinner [model]="loader"></loader-spinner>

<div class="table-responsive">
	<table class="table table-borderless">
		<thead>
			<tr>
				<th class="col-md">
					{{ 'Datagrid.Columns.IbanOuCompte' | translate }}
				</th>
				<th class="col-documents">
					{{ 'Datagrid.Columns.Documents' | translate }}
				</th>
				<th class="col-actions"></th>
			</tr>
		</thead>
		<tbody>
			<tr class="table-row" *ngIf="coordonneeBancaire != null">
				<td class="col-md-6">
					{{coordonneeBancaire.ibanBeneficiaire != null ? coordonneeBancaire.ibanBeneficiaire : coordonneeBancaire.numeroCompte}}
				</td>
				<td class="col-documents">
					<button
						type="button"
						aria-label="Bouton Deposer Document"
						class="btn btn-transparent btn-sm button_icon"
						(click)="handleOpenUploadDocumentsModal($event)"
					>
						<i class="fas fa-file"></i>
						<span class="icon_button__badge" *ngIf="alfrescoDocuments?.length > 0">{{ alfrescoDocuments?.length }}</span>
					</button>
				</td>
				<td class="col-actions">
					<datagrid-actions-dropdown [stopPropagation]="false">
						<button aria-label="Bouton Modifier Rib" class="dropdown-item" type="button" (click)="openCBModal()">
							<i class="far fa-edit"></i>
							{{ (fromBO? 'Actions.Detail':  'Actions.Edit') | translate }}
						</button>
						<button *ngIf="!fromBO" aria-label="Bouton Supprimer Rib" class="dropdown-item" type="button" (click)="confirmDelete()">
							<i class="far fa-trash-alt"></i>
							{{ 'Actions.Delete' | translate }}
						</button>
					</datagrid-actions-dropdown>
				</td>
			</tr>
			<tr *ngIf="coordonneeBancaire == null" datagrid-row-empty [colspan]="4"></tr>
		</tbody>
	</table>
</div>

<div>
	<p class="form-required-fields mb-base">
		<ng-container  *ngIf="coordonneeBancaire != null">
			dernière modification le {{getDateWithoutTime(coordonneeBancaire.dateModification)}} à {{getTime(coordonneeBancaire.dateModification)}} par {{getNomAvocat(coordonneeBancaire.utilisateurModification)}}
		</ng-container>
		<a class="footer-nav-link" style="cursor: pointer;" (click)="getCBHistory()">
			 (consulter l'historique)
		</a>
	</p>
	
</div>
</content-block>

<ng-template #contentBlockActions>
	<button type="button" class="btn btn-primary hasTooltip" *ngIf="!fromBO"
	[disabled]="this.coordonneeBancaire != null" 
	(click)="openCBModal()">
		<span [matTooltip]="addTooltip()">
			<i class="far fa-add"></i>
			{{ 'Actions.NewRib' | translate }}
		</span>		
	</button>
</ng-template>

